module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('target-form-styles', [_c('div', {
    staticClass: "create-target-form__name-section"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('target-name', {
    attrs: {
      "isNewTarget": true,
      "targetType": _vm.target.target,
      "initialValue": _vm.targetNameInitialValue,
      "disabled": false
    },
    on: {
      "updateName": function (val) { return (_vm.target.display_name = val); },
      "updateNameIsValid": function (isValid) { return (_vm.nameIsValid = isValid); }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "create-las__options-area"
  }, [_c('v-row', {
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('advertiser-select', {
    ref: "advertiserSelect",
    staticClass: "vue-select",
    attrs: {
      "label": _vm.hasResearchIntent ? 'Advertiser (Optional)' : 'Advertiser',
      "initialValue": _vm.target.advertiser,
      "disabled": _vm.hasMarketingIntent
    },
    on: {
      "update": function (val) { return (_vm.target.advertiser = val); }
    }
  })], 1), _vm._v(" "), (_vm.hasMarketingIntent) ? _c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('streaming-select', {
    attrs: {
      "viewingOption": 5
    },
    model: {
      value: (_vm.target.viewing_stream),
      callback: function($$v) {
        _vm.$set(_vm.target, "viewing_stream", $$v)
      },
      expression: "target.viewing_stream"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasMarketingIntent) ? _c('v-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('marketing-network-select', {
    ref: "marketingNetworkSelect",
    staticClass: "vue-select",
    attrs: {
      "placeholder": "Select",
      "initialValue": _vm.initialNetwork
    },
    on: {
      "update": function (val) { return _vm.selectedNetwork(val); }
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "evenly-distributed justify-space-around"
  }, [_c('action-button', {
    attrs: {
      "label": _vm.buttonLabel,
      "id": "adBuildAudienceBtn",
      "color": "secondary",
      "disabled": !_vm.buttonClickable
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleSubmit.apply(null, arguments)
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed00118e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/forms/CreateAd.vue
// module id = 1998
// module chunks = 0